<template>
  <b-card no-body class="mb-0">
    <div class="m-2">
      <b-row>
        <b-col cols="12" md="4">
          <b-card no-body class="mb-0">
            <b-card-title>先进单位（共{{ ranks.length }}个）</b-card-title>
            <div class="mb-1">
              学年学期:
              <el-select
                v-model="query.validityId" placeholder="请选择学年学期" style="display:inline-block"
                class="ml-1" @change="handleValidityChange"
              >
                <el-option
                  v-for="item in validityList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>
            <el-table
              :data="ranks"
              @sort-change="handleSortChange"
            >
              <el-table-responsive-column
                type="index"
                label="序号"
                width="60"
              />
              <el-table-responsive-column
                prop="unitName"
                label="单位"
                width="180"
              />
              <el-table-responsive-column label="操作">
                <template slot-scope="scope">
                  <!-- <el-button :disabled="scope.row.status === 1" type="text" @click="addPerson(scope.row)">添加人员</el-button> -->
                  <el-button
                    :disabled="scope.row.status === 1"
                    type="text"
                    @click="handleSetUnitAdvanced(scope.row, false)"
                  >取消
                  </el-button>
                  <!-- <el-button :disabled="scope.row.status === 1" type="text" @click="showDetail(scope.row)">详情</el-button> -->
                </template>
              </el-table-responsive-column>
            </el-table>
          </b-card>
        </b-col>
        <b-col cols="12" md="8">
          <b-card-title>所有单位</b-card-title>
          <div class="title-box">
            <b-row>
              <b-col cols="12" md="6">
                <unitSearch @submitUnitId="submitUnitId" />
                <el-button
                  type="primary"
                  class="ml-1"
                  @click="initPage('search')"
                >查询
                </el-button>
              </b-col>
            </b-row>
          </div>
          <div class="table-box">
            <el-table
              :data="tableData"
              class="responsive"
              @sort-change="handleSortChange"
            >
              <el-table-responsive-column
                type="index"
                label="序号"
                width="60"
              />
              <el-table-responsive-column
                prop="name"
                label="设岗单位"
                width="180"
              />
              <el-table-responsive-column
                prop="totalRating"
                label="评分总人数"
                sortable="custom"
              />
              <el-table-responsive-column
                prop="avgRating"
                label="平均评分"
                sortable="custom"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.avgRating != null">
                    {{ scope.row.avgRating }}
                  </div>
                  <div v-else>
                    -
                  </div>
                </template>
              </el-table-responsive-column>
              <el-table-responsive-column
                prop="sumRating"
                label="总评分"
                sortable="custom"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.sumRating != null">
                    {{ scope.row.sumRating }}
                  </div>
                  <div v-else>
                    -
                  </div>
                </template>
              </el-table-responsive-column>
              <el-table-responsive-column label="操作" width="220">
                <template slot-scope="scope">
                  <el-button
                    :disabled="scope.row.status === 1"
                    type="text"
                    @click="openRatingDetail(scope.row)"
                  >查看评分详情
                  </el-button>
                  <!-- <el-button :disabled="scope.row.status === 1" type="text" @click="addPerson(scope.row)">添加人员</el-button> -->
                  <el-button
                    type="text"
                    :disabled="scope.row.status === 1 || scope.row.advance === true"
                    @click="handleSetUnitAdvanced(scope.row, true)"
                  >
                    设为先进单位
                  </el-button>
                  <!-- <el-button :disabled="scope.row.status === 1" type="text" @click="showDetail(scope.row)">详情</el-button> -->
                </template>
              </el-table-responsive-column>
            </el-table>
          </div>
          <div class="pagination-box">
            <el-pagination
              :current-page="query.pageIndex"
              :page-size="query.pageSize"
              layout="total, prev, pager, next"
              :total="query.totalCount"
              @current-change="handleCurrentChange"
            />
          </div>
        </b-col>
      </b-row>
      <div class="dialog-box">
        <el-dialog
          title="添加人员"
          :visible.sync="addPersonVisible"
          width="550px"
        >
          <div style="margin-bottom: 10px">
            所在岗位:
          </div>
          <el-select
            v-model="unitVal"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in inUnitList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
          <div style="margin: 10px 0">
            学生学号
          </div>
          <div>
            <el-input
              ref="snInput"
              v-model="theStuNum"
              style="width: 65%"
              placeholder="失焦后获取学生"
              @blur="getStudent"
            />
            <el-input
              v-model="stuName"
              style="width: 34%"
              :disabled="true"
            />
          </div>
          <span
            slot="footer"
            class="dialog-footer"
          >
            <el-button @click="addPersonCancel = false">取 消</el-button>
            <el-button
              type="primary"
              @click="addPersonConfirm"
            >确 定</el-button>
          </span>
        </el-dialog>
        <!--  添加管理人员弹框-->
        <AddManagerDialog
          ref="addManagerDia"
          :dia-type="addManagersType"
          :show-dia="addManagersVisible"
          :teachers-list="teachersList"
          :dialog-name="dialogName"
          :dialog-remark="dialogRemark"
          @addUnitConfirm="addUnitConfirm"
          @addUnitCancel="addUnitCancel"
        />
        <!--关闭用工岗位-->
        <warningDialog
          ref="warningDialog"
          title-word="关闭用工单位"
          inner-info="确定要关闭该设岗单位吗？所有该单位下的岗位都将被关闭。"
          :com-firm-btn="closeUnitComfirm"
        />
        <!--单位详情-->
        <el-dialog
          title="单位详情"
          :visible.sync="unitDetailVisible"
          width="550px"
        >
          <el-table
            :data="unitDetailTableData"
            style="width: 100%"
          >
            <el-table-column
              prop="name"
              label="岗位名称"
            />
            <el-table-column
              prop="numberOfOn"
              label="在岗人数"
            />
          </el-table>
          <div>
            <el-pagination
              :current-page.sync="DetailCurrentPage"
              :page-size="5"
              layout="total, prev, pager, next"
              :total="detailDialogTotal"
              @current-change="handleDetailCurrentChange"
            />
          </div>
        </el-dialog>
        <el-dialog
          title="评分详情"
          :visible.sync="ratingDetailVisible"
        >
          <el-table
            :data="ratingDetails"
            class="responsive"
          >
            <el-table-responsive-column
              type="index"
              label="序号"
              width="60"
            />
            <el-table-responsive-column
              prop="sn"
              label="学号"
            />
            <el-table-responsive-column
              prop="name"
              label="姓名"
            />
            <el-table-responsive-column
              prop="name"
              label="姓名"
            />
            <el-table-responsive-column
              prop="jobName"
              label="工作"
            />
            <el-table-responsive-column
              prop="rating"
              label="评分"
            />
            <el-table-responsive-column
              prop="ratingComment"
              label="评论"
            />
          </el-table>
        </el-dialog>
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  unitService, jobService, commonService, applicationService,
} from '@/api/index'
import {
  listUnitRating, listUnitRatingRecords, listUnitRank, saveUnitRank, deleteUnitRank, listValidity,
} from '@/api/api'
import { removeAllSpace, mustBeNum } from '@/tool/utils'
import UnitSearch from '@/components/UnitSearch.vue'
import WarningDialog from '@/components/WarningDialog.vue'
import AddManagerDialog from './module/AddManagerDialog.vue'
// import {mapGetters} from 'vuex'
export default {
  name: 'EmplyUnitManger',
  components: {
    AddManagerDialog,
    WarningDialog,
    UnitSearch,
  },
  data() {
    return {
      unitId: null,
      totalSize: 0,
      currentPage: 0,
      detailDialogTotal: 0,
      DetailCurrentPage: 1,
      tableData: [],
      addPersonVisible: false,
      // dialog所在岗位list
      inUnitList: [],
      // dialog所在岗位值
      unitVal: null,
      // 添加管理员弹框title
      addManagersType: null,
      // 管理员添加弹框显示
      addManagersVisible: false,
      // 添加用工单位弹框教师数组
      teachersList: [],
      // 详情显示
      unitDetailVisible: false,
      // 单位详情list
      unitDetailTableData: [],
      // 查询学生学号
      theStuNum: null,
      // 查询的学生学号
      stuName: null,
      // 详情单位id
      detailId: null,
      // 关闭id
      closeId: null,
      dialogName: '',
      dialogRemark: '',
      // 添加学生观参数
      addStuParams: {
        jobId: null,
        sn: null,
      },
      // 编辑选择的id
      chooseId: null,
      query: {
        pageIndex: 1,
        pageSize: 10,
        totalCount: 0,
        orderBy: 'totalRating:DESC',
        validityId: null,
      },
      ratingDetails: [],
      ratingDetailVisible: false,
      ranks: [],
      validityList: [],
    }
  },
  mounted() {
    this.loadValidityList()
  },
  methods: {
    initPage() {
      listUnitRating(this.query)
        .then(res => {
          if (res.status) {
            this.tableData = res.data
            this.query.totalCount = res.page.totalCount
          }
        })
    },
    loadUnitRank() {
      listUnitRank({
        pageSize: -1,
        validityId: this.query.validityId,
      })
        .then(res => {
          if (res.status) {
            this.ranks = res.data
          }
        })
    },
    loadValidityList() {
      listValidity()
        .then(res => {
          if (res.status) {
            this.validityList = res.data
            this.query.validityId = res.data[res.data.length - 1].id
            this.initPage()
            this.loadUnitRank()
          }
        })
    },
    handleSortChange(cond) {
      this.query.orderBy = `${cond.prop}:${cond.order === 'ascending' ? 'ASC' : 'DESC'}`
      this.initPage()
    },
    handleSetUnitAdvanced(row, flag) {
      if (flag) {
        this.$confirm('确定设为先进单位吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            saveUnitRank({
              unitId: row.id,
              validityId: this.query.validityId,
            })
              .then(res => {
                if (res.status) {
                  this.loadUnitRank()
                  this.initPage()
                }
              })
          })
      } else {
        this.$confirm('确定取消先进单位吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            deleteUnitRank(row.id)
              .then(res => {
                if (res.status) {
                  this.loadUnitRank()
                  this.initPage()
                }
              })
          })
      }
    },
    openRatingDetail(row) {
      this.curRating = row
      listUnitRatingRecords({
        unitId: row.id,
        pageSize: -1,
      })
        .then(res => {
          if (res.status) {
            this.ratingDetails = res.data
            this.ratingDetailVisible = true
          }
        })
    },
    submitUnitId(id) {
      this.query.unitId = id
    },
    handleCurrentChange(val) {
      this.query.pageIndex = val
      this.initPage()
    },
    handleDetailCurrentChange(val) {
      const params = {
        page: val - 1,
        size: 5,
        unitId: this.detailId,
      }
      jobService()
        ._unitSearch(params)
        .then(res => {
          if (res.status) {
            this.unitDetailTableData = res.data.content
            this.detailDialogTotal = res.data.totalElements
          }
        })
    },
    handleValidityChange(val) {
      this.query.validityId = val
      this.initPage()
      this.loadUnitRank()
    },
    // 添加人员
    addPerson(row) {
      // 清空之前数据
      this.theStuNum = null
      this.stuName = null
      this.unitVal = null
      // 获取所在单位的所有单位
      // jobService()._jobsOfUnit({unitId: row.id}).then(res => {
      //   if (res.status) {
      //     this.inUnitList = res.data
      //   }
      // })
      // this.addPersonVisible = true
      this.$router.push({
        name: 'WorkingStudentManage',
        query: {
          unitId: row.id,
        },
      })
    },
    // 添加人员确定
    // eslint-disable-next-line consistent-return
    async addPersonConfirm() {
      this.addStuParams.jobId = this.unitVal
      this.addStuParams.sn = this.theStuNum
      // later
      if (this.addStuParams.jobId === null || this.addStuParams.jobId === '') {
        this.$message.warning('请选择所在岗位')
        return false
      }
      await this.$refs.snInput.blur()
      if (!this.stuName) {
        return false
      }
      applicationService()
        ._addToUnit(this.addStuParams)
        .then(res => {
          if (res.status) {
            this.$message.success('操作成功')
            this.addPersonVisible = false
            this.initPage()
          }
        })
    },
    // 添加管理人员
    addManagers() {
      this.teachersList = []
      this.dialogName = ''
      this.dialogRemark = ''
      this.addManagersType = 'add'
      this.$refs.addManagerDia.dialogVisibel = true
    },
    // 编辑管理人员
    editManagers(row) {
      this.dialogName = row.name
      this.dialogRemark = row.remark
      this.teachersList = []
      this.chooseId = row.id
      row.teacherList.forEach(x => {
        const params = {
          sn: x.userName,
          name: x.realName,
        }
        this.teachersList.push(params)
      })
      this.addManagersType = 'edit'
      this.$refs.addManagerDia.dialogVisibel = true
    },
    // 关闭
    closeUnit(row) {
      this.closeId = row.id
      this.$refs.warningDialog.dialogVisible = true
    },
    // 关闭用工单位确认按钮
    closeUnitComfirm() {
      unitService()
        ._closeUnit({ id: this.closeId })
        .then(res => {
          if (res.status) {
            this.$message.success('操作成功')
            this.$refs.warningDialog.dialogVisible = false
            this.initPage()
          }
        })
    },
    // 详情
    showDetail(row) {
      this.detailId = row.id
      this.DetailCurrentPage = 1
      const params = {
        page: 0,
        size: 5,
        unitId: this.detailId,
      }
      jobService()
        ._unitSearch(params)
        .then(res => {
          if (res.status) {
            this.unitDetailTableData = res.data.content
            this.detailDialogTotal = res.data.totalElements
          }
        })
      this.unitDetailVisible = true
    },
    // 获取学生
    // eslint-disable-next-line consistent-return
    getStudent() {
      this.theStuNum = removeAllSpace(this.theStuNum)
      if (!mustBeNum(this.theStuNum)) {
        this.$message.warning('请输入数字')
        return false
      }
      commonService()
        ._getStudent(this.theStuNum)
        .then(res => {
          if (res.status) {
            this.stuName = res.data.realName
          } else {
            this.stuName = null
          }
        })
    },
    // 添加人员确定
    addUnitConfirm(item) {
      if (this.addManagersType === 'edit') {
        Object.assign(item.unitDto, { unitId: this.chooseId })
      }
      // this.dialogName = ''
      unitService()
        ._addUnit(item)
        .then(res => {
          if (res.status) {
            this.$message.success('操作成功')
            this.$refs.addManagerDia.dialogVisibel = false
            this.currentPage = 0
            this.initPage()
          }
        })
    },
    addUnitCancel() {
      this.dialogName = ''
      this.$refs.addManagerDia.dialogVisibel = false
    },
  },
}
</script>

<style scoped>
</style>
